<template>
  <div class="share">
    <div class="tags">
      <span
        class="badge badge-primary"
        v-for="(tag, i) in tags"
        :key="i"
        v-text="tag"
      ></span>
    </div>
    <div class="links">
      <a href="" class="copy" @click.prevent="copyLink">
        <i class="fa fa-link mr-1"></i>
        <span>Copy Link</span>
      </a>
      <a
        :href="`https://www.facebook.com/sharer/sharer.php?u=${url}`"
        target="_blank"
        aria-label="Share on Facebook"
      >
        <i class="fab fa-facebook-f"></i>
      </a>
      <a
        :href="`https://twitter.com/intent/tweet?url=${url}`"
        target="_blank"
        aria-label="Share on Twitter"
      >
        <i class="fab fa-twitter"></i>
      </a>
      <a
        :href="`https://www.linkedin.com/shareArticle?mini=true&url=${url}`"
        target="_blank"
        aria-label="Share on LinkedIn"
      >
        <i class="fab fa-linkedin-in"></i>
      </a>
      <a
        :href="`https://wa.me/?text=${url}`"
        target="_blank"
        aria-label="Share on WhatsApp"
      >
        <i class="fab fa-whatsapp"></i>
      </a>
    </div>
  </div>
</template>
<script>
export default {
  props: {
    tags: {
      type: Array,
      required: false,
      default: () => [],
    },
  },
  data() {
    return {
      url: window.location.href,
    };
  },
  methods: {
    copyLink() {
      navigator.clipboard.writeText(this.url);

      this.success_alert("Link copied to clipboard");
    },
  },
};
</script>
<style lang="scss" scoped>
.share {
  display: flex;
  flex-direction: row;
  justify-content: space-between;
  align-items: flex-end;
  padding: 0.4rem 1rem;
  flex-wrap: wrap;
  gap: 1rem;
  margin-bottom: 0.5rem;

  .links {
    display: flex;
    flex-direction: row;
    align-items: center;
    flex-wrap: wrap;
    gap: 0.5rem;
    a {
      display: inline-block;
      background: var(--color-light);
      color: var(--dark);
      font-size: 1rem;
      transition: all 0.2s ease-in-out;
      border-radius: 8px;
      border: 1.9px solid var(--light);
      padding: 0.2rem 0.6rem;
      i,
      span {
        opacity: 0.8;
      }

      &.copy {
        span {
          font-weight: 600;
          font-size: 90%;
          position: relative;
          top: -1px;
        }
      }

      &:hover {
        box-shadow: var(--box-shadow);
        i,
        span {
          opacity: 1;
        }
      }
    }
  }
}

.tags {
  display: flex;
  flex-wrap: wrap;
  flex-direction: row;
  align-items: center;
  gap: 0.5rem;
  .badge {
    font-size: 85%;
    padding: 0.35em 0.7em;
  }
}
</style>